import React from 'react';

const Card = ({ children }) => <div className="plan-card">{children}</div>;

export default Card
